import { type FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@zawarski/eti-ui';
import { Provider } from 'react-redux';
import { store } from '@/store';
import useJSXRoutes from '@/routes';
import { ThemeProvider } from '@/hooks/ThemeContext';

const AppContent: FC = () => {
  const router = useJSXRoutes();

  return (
    <Provider store={store}>
      <Toaster position='top-right' richColors duration={2000} visibleToasts={5} />
      <RouterProvider router={router} />
    </Provider>
  );
};

const App: FC = () => {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App;
